import { render } from "./DialogLoading.vue?vue&type=template&id=02b28cf8"
import script from "./DialogLoading.vue?vue&type=script&lang=js"
export * from "./DialogLoading.vue?vue&type=script&lang=js"
script.render = render

export default script